import { Select, Space } from "antd"
import { MODES } from "./CustomerOrFundSelect"

export const PositionsModeSelect = ({ value, setValue, disabled }) => {
  return (
    <Space>
      <b>Positions:</b>
      <Select value={value} onChange={(value) => setValue(value)} disabled={disabled}>
        <Select.Option value={MODES.CUSTOMER}>Customers</Select.Option>
        <Select.Option value={MODES.FUND}>TERA Funds</Select.Option>
      </Select>
    </Space>
  )
}
